import React from 'react';
import Lottie from 'lottie-react';
import animationData from './Btn_arrow_animation.json';
import "./Btn_arrow_animation.css";

function Btn_arrow_animation() {
  return (
    <section className='Btn_arrow_animation'>
      <Lottie
        animationData={animationData}
        loop={true}
        autoplay={true}
        className="arrow_lottie"
      />
    </section>
  );
}

export default Btn_arrow_animation;
